var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Carpet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Yf4jjlKkubwNqgwf6908ta",
    x1: 20.788,
    x2: 32.109,
    y1: 9.553,
    y2: 40.657,
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442\\u043D\\u043E\\u0439 \\u0437\\u0430\\u043B 3",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Yf4jjlKkubwNqgwf6908tc",
    x1: 4.799,
    x2: 15.885,
    y1: 15.459,
    y2: 45.916,
    xlinkHref: "#Yf4jjlKkubwNqgwf6908ta"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Yf4jjlKkubwNqgwf6908tb",
    x1: 27.06,
    x2: 17.485,
    y1: 41.641,
    y2: 16.639,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 18",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6d6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Yf4jjlKkubwNqgwf6908td",
    x1: 41.06,
    x2: 31.485,
    y1: 41.641,
    y2: 16.639,
    xlinkHref: "#Yf4jjlKkubwNqgwf6908tb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Yf4jjlKkubwNqgwf6908ta)",
    d: "M38.51351,18H9V36H38.51351A9.25287,9.25287,0,0,0,48,27,9.25283,9.25283,0,0,0,38.51351,18Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 27,
    r: 9,
    fill: "#50e6ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 27,
    r: 7,
    fill: "url(#Yf4jjlKkubwNqgwf6908tc)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 27,
    r: 5,
    fill: "#50e6ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 27,
    r: 3,
    fill: "url(#Yf4jjlKkubwNqgwf6908tc)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 27,
    r: 1,
    fill: "#50e6ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Yf4jjlKkubwNqgwf6908tb)",
    d: "M23,36H18a10.18371,10.18371,0,0,0,0-18h5C29,21.99925,29,31.99925,23,36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Yf4jjlKkubwNqgwf6908td)",
    d: "M37,36H32a10.18371,10.18371,0,0,0,0-18h5C43,21.99925,43,31.99925,37,36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Carpet);
export default __webpack_public_path__ + "static/media/icons8-carpet.c802e9969113b31a2906fb2e6ea4f806.svg";
export { ForwardRef as ReactComponent };